module.exports = __webpack_public_path__ + "img/2.cd64999d.png";